<template>
	<div>
		<h3>
			<q-icon class="icon-fleche"/>
			Agissez sur les réseaux sociaux
		</h3>

		<p>
			Alertez sur la «&nbsp;déforestation made in France&nbsp;» sur votre réseau social préféré.
		</p>

		<ul>
			<li>
				Sur Facebook, <a href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.greenpeace.fr%2Fdeforestation-made-in-france" target="_share" @click="shareFacebook">cliquez ici</a> pour partager cette page.
			</li>
			<li>
				Sur Twitter, <a href="https://twitter.com/intent/tweet?text=%E2%9A%A0%EF%B8%8F%20%23HuiledePalme%20%3A%20le%20gouvernement%20ne%20doit%20pas%20c%C3%A9der%20aux%20caprices%20de%20%40Total.%20%40Elisabeth_Borne%20faites%20respecter%20le%20vote%20du%20Parlement%20et%20supprimez%20pour%20de%20bon%20la%20niche%20fiscale.%20Stop%20%C3%A0%20l%E2%80%99huile%20de%20palme%20dans%20nos%20moteurs%20!%20%23Deforestation%20%23MedeInFrance&url=https%3A%2F%2Fwww.greenpeace.fr%2Fdeforestation-made-in-france%2F" target="_share" @click="shareTwitter">cliquez ici</a>&nbsp;! N’hésitez pas à personnaliser le message pré-écrit, ça lui donnera encore plus de visibilité.
			</li>
			<li>
				Sur Whatsapp, <a href="https://api.whatsapp.com/send?text=Hey%20!%20Tu%20savais%20que%20l%E2%80%99%C3%A9quivalent%20d%E2%80%99un%20terrain%20de%20football%20de%20for%C3%AAt%20est%20d%C3%A9truit%20toutes%20les%2025%20secondes%20en%20Indon%C3%A9sie%20%3F%20Des%20for%C3%AAts%20enti%C3%A8res%20sont%20ras%C3%A9es%20pour%20cultiver%20de%20l'huile%20de%20palme%2C%20qui%20termine%20dans%20les%20moteurs%20des%20voitures.%20C'est%20un%20d%C3%A9sastre%20pour%20les%20for%C3%AAts%2C%20pour%20le%20climat%2C%20pour%20nous%20tous%20et%20toutes%20!%20Le%20gouvernement%20doit%20supprimer%20la%20niche%20fiscale%20pour%20l%E2%80%99huile%20de%20palme%2C%20c%E2%80%99est%20urgent%20!%20Aide-moi%20%C3%A0%20faire%20passer%20le%20message%20pour%20stopper%20la%20d%C3%A9forestation%20import%C3%A9e%20!%20RDV%20sur%20https%3A%2F%2Fwww.greenpeace.fr%2Fdeforestation-made-in-france%2F" target="_share" @click="shareWhatsapp">partagez ce message</a> à vos proches. Plus vous parviendrez à mobiliser autour de vous, plus notre action aura des chances d'aboutir&nbsp;!
			</li>
		</ul>

		<p>
			Voici un exemple de post à partager sur vos réseaux dans lequel vous pouvez taguer la ministre Elisabeth Borne&nbsp;:
		</p>

		<p>
			<em>
				⚠️ #HuiledePalme : le gouvernement ne doit pas céder aux caprices de @Total. @Elisabeth_Borne faites respecter le vote du Parlement et supprimez pour de bon la niche fiscale ! Stop à l’huile de palme dans nos moteurs, dites non aux agrocarburants ! https://www.greenpeace.fr/deforestation-made-in-france
			</em>

		</p>

	</div>
</template>

<script>

export default {
	methods: {
		shareWhatsapp() {
			this.$count()
			this.$trackEvent("click", "partage whatsapp")
		},
		shareTwitter() {
			this.$count()
			this.$trackEvent("click", "partage twitter")
		},
		shareFacebook() {
			this.$count()
			this.$trackEvent("click", "partage facebook")
		},
	}
}
</script>